import React, { Component } from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import { InputText } from "primereact/inputtext";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import { Dropdown } from "primereact/dropdown";
import AccessRightService from "../../services/AccessRightService";
import UserService from "../../services/UserService";
import MessageComponent from "../../template/Message";
import { BreadCrumb } from "primereact/breadcrumb";
import { Card } from "primereact/card";

export default class AccessRight extends Component {
  constructor(props) {
    super(props);
    this.AccessRightService = new AccessRightService();
    this.UserService = new UserService();
    this.state = {
      visible: false,
      nodes: [],
      globalFilter: null,
      UserId: 0,
      formError: {
        UserId: null,
      },
      userddlList: [],
    };

    this.checkBox = this.checkBox.bind(this);
    this.SubmitData = this.SubmitData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChildCheck = this.handleChildCheck.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.GetUserList();
    }, 100);
  }

  GetUserList() {
    this.UserService.GetUsersDDL().then((data) => {
      const resdata = data.data;
      if (resdata !== null && resdata.ResponseCode === "200") {
        this.setState({
          userddlList: resdata.ResponseData,
        });
      }
    });
  }

  handleChildCheck(nodeIndex, childKey, isChecked) {
    const updatedNodes = this.state.nodes.map((node, i) => {
      if (i === nodeIndex) {
        return {
          ...node,
          children: node.children.map((child) =>
            child.key === childKey ? { ...child, Status: isChecked } : child,
          ),
        };
      }
      return node;
    });
    this.setState({ nodes: updatedNodes });
  }

  handleSelectAll(nodeIndex, isChecked) {
    const updatedNodes = this.state.nodes.map((node, i) => {
      if (i === nodeIndex) {
        return {
          ...node,
          children: node.children.map((child) => ({
            ...child,
            Status: isChecked,
          })),
        };
      }
      return node;
    });
    this.setState({ nodes: updatedNodes });
  }

  areAllChecked(node) {
    if (!node.children || node.children.length === 0) return false;
    return node.children.every((child) => child.Status === true);
  }

  handleChange(event) {
    const { name, value } = event.target;
    let errors = this.state.formError;
    switch (name) {
      case "UserId":
        errors.UserId = value === "" ? "Please select user." : "";
        break;
    }
    this.setState({ errors, [name]: value });
  }

  onUserChange(e) {
    const userId = parseInt(e.target.value);

    this.AccessRightService.GetAccessRight(userId).then((data) => {
      this.setState({
        nodes: data.data.ResponseData,
      });
    });

    this.handleChange(e);
  }

  checkBox(rowData) {
    return (
      <div>
        <input disabled checked={rowData.Status} type="checkbox" />
      </div>
    );
  }

  SubmitData() {
    const { nodes, UserId } = this.state;
    let checkedValuelst = [];
    // let checkedValuelst = ["1"];

    // nodes.forEach((parent) => {
    //   let parentIncluded = false;
    //   parent.children.forEach((child) => {
    //     if (child.Status === true) {
    //       checkedValuelst.push(child.key);
    //       parentIncluded = true;
    //     }
    //   });
    //   if (parentIncluded) {
    //     checkedValuelst.push(parent.key);
    //   }
    // });
    nodes.forEach((parent) => {
      if (!parent.children || parent.children.length === 0) {
        if (parent.Status === true) {
          checkedValuelst.push(parent.key);
        }
        return;
      }

      let parentIncluded = false;
      parent.children.forEach((child) => {
        if (child.Status === true) {
          checkedValuelst.push(child.key);
          parentIncluded = true;
        }
      });
      if (parentIncluded) {
        checkedValuelst.push(parent.key);
      }
    });

    const formData = {
      UserId: UserId,
      PageList: checkedValuelst,
    };

    if (formData.UserId > 0) {
      this.AccessRightService.CreateUpdateAccessRight(formData).then((data) => {
        const resdata = data.data;
        if (resdata !== null && resdata.ResponseCode === "200") {
          this.refs.Messchild.showSuccess(resdata.ResponseMessage);
        } else {
          this.refs.Messchild.showError(resdata.ResponseMessage);
        }
      });
    } else {
      let errors = this.state.formError;
      errors.UserId = "Please select user";
      this.setState({ formError: errors });
    }

    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
  handleParentCheck(nodeIndex, isChecked) {
    const updatedNodes = this.state.nodes.map((node, i) =>
      i === nodeIndex ? { ...node, Status: isChecked } : node,
    );
    this.setState({ nodes: updatedNodes });
  }
  render() {
    const items = [{ label: "Masters" }, { label: "Access Right" }];
    const home = { icon: "pi pi-home", url: "/dashboard" };
    const TreeNode = this.state.nodes;

    const TreeStruture = TreeNode.map((node, i) => (
      <div key={node.key}>
        <Accordion>
          <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
            <Typography style={{ fontSize: "1vw" }}>
              {(!node.children || node.children.length === 0) && (
                <input
                  type="checkbox"
                  checked={node.Status === true}
                  onChange={(e) => this.handleParentCheck(i, e.target.checked)}
                  style={{ marginRight: "8px" }}
                />
              )}
              {node.data.pages}
            </Typography>
          </AccordionSummary>

          {node.children && node.children.length > 0 && (
            <AccordionDetails>
              <ul className="tree-stucture">
                <li>
                  <input
                    type="checkbox"
                    checked={this.areAllChecked(node)}
                    onChange={(e) => this.handleSelectAll(i, e.target.checked)}
                  />{" "}
                  Select all
                </li>
                {node.children.map((childNode) =>
                  childNode.data.pages === "Issue Number" ? null : (
                    <li key={childNode.key}>
                      <input
                        name="childCheck"
                        value={childNode.key}
                        type="checkbox"
                        checked={childNode.Status === true}
                        onChange={(e) =>
                          this.handleChildCheck(
                            i,
                            childNode.key,
                            e.target.checked,
                          )
                        }
                      />{" "}
                      {childNode.data.pages}
                    </li>
                  ),
                )}
              </ul>
            </AccordionDetails>
          )}
        </Accordion>
        <br />
      </div>
    ));
    return (
      <>
        <MessageComponent ref="Messchild" />
        <Card>
          <div className="row mb-3">
            <div className="col-md-6 heading">
              <h1>Access Right</h1>
            </div>
            <div className="col-md-6 custom-breadcrumb">
              <BreadCrumb model={items} home={home} />
            </div>
          </div>

          <div>
            <h3 className="mt-4 mb-4">Select User</h3>
            <form>
              <Dropdown
                filter
                style={{ width: "300px" }}
                options={this.state.userddlList}
                placeholder="Select User"
                className="form-control mb-4"
                value={this.state.UserId}
                onChange={this.onUserChange.bind(this)}
                name="UserId"
              />
              {this.state.formError.UserId && (
                <div className="error">{this.state.formError.UserId}</div>
              )}
            </form>
          </div>
        </Card>

        <span hidden={TreeStruture.length > 0 ? false : true}>
          <div className="border-box">
            <h3 className="mt-3 mb-4">Select Pages</h3>
            {TreeStruture}
          </div>
          <div className="text-center mt-2 pb-3">
            <button
              type="button"
              onClick={this.SubmitData}
              className="btn btn-primary"
            >
              Submit
            </button>
          </div>
        </span>
      </>
    );
  }
}
